import { SearchState, FunctionMap, Query, SearchFilters } from '../../types';
import { SET_SEARCH_QUERY, SET_SEARCH_ALL, SET_LAST_QUERY, CLEAR_STORIES, SET_SEARCH_FILTERS } from '../constants';
import { createReducer } from './Utils';
import { SetSearchFilters, FSAInterface } from '../actions';
import { orderValues, postsShownValues } from '../../constants';

export const defaultFiltersState = {
  postsShown: postsShownValues.UNPINNED,
  order: orderValues.DESC,
};

const searchDefaultState: SearchState = {
  query: '',
  searchAll: false,
  lastQuery: {} as Query,
  filters: defaultFiltersState as SearchFilters,
};

function setQuery(state: SearchState, action: any) {
  return { ...state, query: action.query };
}

function setSearchAll(state: SearchState, action: any) {
  return { ...state, searchAll: action.searchAll };
}

function setLastQuery(state: SearchState, action: any) {
  return { ...state, lastQuery: action.lastQuery };
}

function clearLastQuery(state: SearchState) {
  return { ...state, lastQuery: {} };
}

function setFilters(state: SearchState, action: FSAInterface<SetSearchFilters['payload']>) {
  const { payload } = action;
  return { ...state, filters: { ...state.filters, ...payload?.filters } };
}

const functionMap: FunctionMap = {
  [SET_SEARCH_QUERY]: setQuery,
  [SET_SEARCH_ALL]: setSearchAll,
  [SET_LAST_QUERY]: setLastQuery,
  [CLEAR_STORIES]: clearLastQuery,
  [SET_SEARCH_FILTERS]: setFilters,
};

export default createReducer(functionMap, searchDefaultState);
